import { motion } from "framer-motion";
import { Shield, Clock, Headphones, Lock, CheckCircle, Users } from "lucide-react";

const guarantees = [
  {
    icon: Clock,
    title: "Setup Rápido",
    description: "Operando em minutos",
    color: "cyber-cyan",
  },
  {
    icon: Headphones,
    title: "Suporte Dedicado",
    description: "Atendimento humanizado",
    color: "electric-purple",
  },
  {
    icon: Users,
    title: "Suporte Brasileiro",
    description: "Atendimento humanizado",
    color: "cyber-cyan",
  },
  {
    icon: Lock,
    title: "LGPD Compliance",
    description: "Dados 100% protegidos",
    color: "electric-purple",
  },
  {
    icon: Shield,
    title: "99.9% Uptime",
    description: "Garantia de estabilidade",
    color: "cyber-cyan",
  },
  {
    icon: CheckCircle,
    title: "API Oficial Meta",
    description: "Nativa e configurável",
    color: "electric-purple",
  },
];

const GuaranteesSection = () => {
  return (
    <section id="garantias" className="py-12 md:py-16 relative" aria-labelledby="guarantees-heading">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-cyber-cyan/5 via-transparent to-electric-purple/5" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8 md:mb-12"
        >
          <h2 id="guarantees-heading" className="text-xl sm:text-2xl md:text-3xl font-display font-bold mb-2">
            Por Que Confiar na{" "}
            <span className="text-gradient-zavvi">Zavvi?</span>
          </h2>
          <p className="text-sm md:text-base text-body-text">
            Garantias que você não encontra em nenhum concorrente
          </p>
        </motion.div>

        {/* Guarantees Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 max-w-6xl mx-auto">
          {guarantees.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="glass-card p-4 md:p-6 rounded-xl text-center hover:border-cyber-cyan/30 transition-all duration-300 group"
            >
              <div
                className={`w-10 h-10 md:w-12 md:h-12 rounded-lg bg-${item.color}/10 flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300`}
              >
                <item.icon className={`w-5 h-5 md:w-6 md:h-6 text-${item.color}`} />
              </div>
              <h3 className="text-xs md:text-sm font-bold text-foreground mb-1">
                {item.title}
              </h3>
              <p className="text-[10px] md:text-xs text-muted-foreground">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuaranteesSection;
